import { Button } from "@mui/material";
import { useSeeAllClientsIdsInWaitingListLazyQuery } from "@src/graphql/generated/WaitingList.queries.generated";
import React from "react";

type ActionsProps = {};

const SeeIncorrectClientsInWaitingList: React.FC<ActionsProps> = () => {

    const [getAllClientsIdsInWaitingList] = useSeeAllClientsIdsInWaitingListLazyQuery({
        fetchPolicy: "network-only",
        onCompleted: (data) => {
            const incorrectWaitingListItems = data.waiting_list.filter((waitingListItem) => {
                for (const caseloadClientId of waitingListItem.waiting_list_waiting_list_items) {
                    if(caseloadClientId.caseload!! && caseloadClientId.caseload?.client_id !== waitingListItem.client_id) {
                        return true;
                    }
                }
                return false;
            })
            console.log("data", incorrectWaitingListItems);
        },
    });

    return (
        <div>
            <Button
                variant="contained"
                color="primary"
                onClick={() => getAllClientsIdsInWaitingList()}
                fullWidth
            >
                See Incorrect Clients in Waiting List
            </Button>
        </div>
    );
};

export default SeeIncorrectClientsInWaitingList;
